import * as z from 'zod';

export const registerSchema = z.object({
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  phoneNumber: z.string().min(10, 'Phone number is required'),
  email: z.string().email('Please enter a valid email address'),
  dateOfBirth: z
    .string()
    .regex(
      /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/,
      'Date of birth must be in mm/dd/yyyy format'
    ),
  gender: z.string().min(1, 'Gender is required'),
  agreeToTexts: z.boolean(),
  cancellationPolicy: z.boolean(),
  spanishCommunication: z.boolean(),
  isInternalVolunteer: z.boolean()
});

export type RegisterFormData = z.infer<typeof registerSchema>;

export type RegisterEventPayload = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  gender: string;
  acceptedPhoneTermsAt: string;
  acceptedCancellationPolicyAt: string;
  acceptedTermsAndConditionsAt: string;
  prefersSpanishCommunication: boolean;
  birthDate: string;
  isInternalVolunteer: boolean;
};

export const checkEmailSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
  phoneNumber: z.string().optional()
});

export type CheckFormPayload = z.infer<typeof checkEmailSchema>;

export const forgotPasswordSchema = z.object({
  email: z.string().email('Please enter a valid email address')
});

export type ForgotPasswordPayload = z.infer<typeof forgotPasswordSchema>;

export const forgotPasswordVerifyOtpSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
  otp: z.string().min(6, 'OTP must be 6 digits').max(6, 'OTP must be 6 digits')
});

export type ForgotPasswordVerifyOtpPayload = z.infer<
  typeof forgotPasswordVerifyOtpSchema
>;

export const forgotPasswordResetSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
  token: z.string().min(1, 'Reset token is required'),
  password: z.string().min(1, 'Password is required')
});

export type ForgotPasswordResetPayload = z.infer<
  typeof forgotPasswordResetSchema
>;
